import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PartyService } from '../Services/party.service';
import { FormGroup, FormArray, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { IWorker } from "../Interfaces/worker";
import { RosterValidatorService } from '../Services/roster-validator.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { NgIf, NgFor } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'app-roster-list',
    templateUrl: './roster-list.component.html',
    styleUrls: ['./roster-list.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatCheckbox, NgFor, MatPaginator, MatFormField, MatInput, MatButton, MatDivider]
})
export class RosterListComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() ID: string;
  @Input() meetingID: string;
  @Input() MeetingRecord?: any;
  @Output() foundWorkersEvent = new EventEmitter <Array<any>>();
  pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  totalCount: number = 100;
  pageNewContactIndex: number = 0;
  pageNewContactSize: number = 10;
  totalNewContactCount: number;
  workers: IWorker[] = [];
  addContact: FormGroup = null;
  slicedArray: any;

  constructor(private partyService: PartyService, private rosterValidatorService: RosterValidatorService) { }
  get rosterArray(): FormArray {
    return this.group.get('Roster') as FormArray;
  }

  get newContactArray(): FormArray {
    return this.group.get('NewContacts') as FormArray;
  }
  ngOnInit(): void {
    this.addContact = this.BlankContact();
    //if (this.rosterArray.controls.length === 0)
    this.totalNewContactCount = this.newContactArray.length;
      this.getNextPage(null);

      this.group.get('SelectAll').valueChanges.subscribe(val => {
              this.rosterArray.controls.forEach(x=>x.get("isSelected").setValue(val));
        });

  }
  public getNewContactNextPage(event?: PageEvent) {

  }

  public getNextPage(event?: PageEvent) {
    let worksiteID = '/'+this.ID+'/'
    let Offset = 0;
    console.log(event);
    Offset = event !== null ? event.pageSize * event.pageIndex : 0;
    console.log(Offset);
    console.log(this.MeetingRecord.Entity);
    if (event === null || event.pageIndex >= event.previousPageIndex){
      const attendanceListUrl = this.meetingID ? "$/_i4u_/Core/Contact Layouts/Organisations/Meeting Roster/AttendanceListExceptMeeting" : "$/_i4u_/Core/Contact Layouts/Organisations/Meeting Roster/AttendanceList";
      this.partyService.getIQAResult(attendanceListUrl, worksiteID, this.MeetingRecord.Entity, this.meetingID, (event === null ? this.pageSize : event.pageSize), Offset).subscribe(
        data => {
      
          this.pageSize = data.Limit
          this.totalCount = data.TotalCount;
          this.pageIndex = data.Offset / data.Limit;

          data.Items.$values.forEach(element => {
            // don't do clientside filtering: get distinct ids from IQA so totalCount and items count per page is correct
            // if (this.workers.findIndex(x => x.id === element.Properties.$values.find(y=>y.Name ==="iMIS ID").Value) <= 0){
              this.workers.push({
                id: element.Properties.$values.find(y=>y.Name ==="iMIS ID").Value,
                isSelected: this.group.get("SelectAll").value,
                memberType: element.Properties.$values.find(y=>y.Name ==="MemberType").Value,
                firstName: element.Properties.$values.find(y=>y.Name ==="FirstName").Value,
                //  middleName: element.Properties.$values.find(y=>y.Name ==="MiddleName").Value,
                lastName: element.Properties.$values.find(y=>y.Name ==="LastName").Value,
                mobilePhone: element.Properties.$values.find(y=>y.Name ==="MobilePhone").Value,
                email: element.Properties.$values.find(y=>y.Name ==="Email").Value,
                workPhone: element.Properties.$values.find(y=>y.Name ==="WorkPhone").Value,
                status: "M"
              });
            // }
          });
          
          
          this.foundWorkersEvent.emit(this.workers);

          this.BuildControls(event);
          //   this.rosterArray.setValidators(this.rosterValidatorService.rosterValidator());
          //   this.rosterArray.updateValueAndValidity();
        },
        error => console.log(error)
      );
    } else {
      this.BuildControls(event);
    }

  }

  BuildControls(event?: PageEvent): void {
   if (event === null || event.pageIndex >= event.previousPageIndex) {
      this.workers.forEach(worker => {

        this.AddWorkerControls(worker);
      });
      this.rosterArray.setValidators(this.rosterValidatorService.rosterValidator());
      this.rosterArray.updateValueAndValidity();
    }
    this.slicedArray = null;
    if (event === null)
      this.slicedArray = this.rosterArray.controls.slice(0, ((this.pageIndex + 1) * this.pageSize));
    else {
      console.log(event);
      console.log(this.rosterArray);
      console.log(this.slicedArray);
      this.slicedArray = this.rosterArray.controls.slice((event.pageIndex * event.pageSize), ((event.pageIndex + 1) * event.pageSize));
      console.log(this.slicedArray);
    }


  }
  AddWorkerControls(worker: IWorker) {
    if (this.rosterArray.controls.findIndex(x => x.get("id").value === worker.id) >= 0) {
      return;
    }
    let group: any = {};
    group["isSelected"] = new FormControl(worker.isSelected);
    group["id"] = new FormControl(worker.id);
    group["memberType"] = new FormControl(worker.memberType);
    group["firstName"] = new FormControl(worker.firstName);
   // group["middleName"] = new FormControl(worker.middleName);
    group["lastName"] = new FormControl(worker.lastName);
    group["mobilePhone"] = new FormControl(worker.mobilePhone);
    group["email"] = new FormControl(worker.email);
    group["workPhone"] = new FormControl(worker.workPhone);
    group["status"] = new FormControl(worker.status);

    this.rosterArray.push(new FormGroup(group));
    group = {};
  }

  AddNewWorkerControls(worker: IWorker) {
    if (this.rosterArray.controls.findIndex(x => x.get("id").value === worker.id) >= 0)
      return;
    let group: any = {};
    group["isSelected"] = new FormControl(worker.isSelected);
    group["id"] = new FormControl(worker.id);
    group["memberType"] = new FormControl(worker.memberType);
    group["firstName"] = new FormControl(worker.firstName.trim());
    group["middleName"] = new FormControl(worker.middleName.trim());
    group["lastName"] = new FormControl(worker.lastName.trim());
    group["mobilePhone"] = new FormControl(worker.mobilePhone.trim());
    group["email"] = new FormControl(worker.email.trim());
    group["workPhone"] = new FormControl(worker.workPhone.trim());
    group["status"] = new FormControl(worker.status.trim());
    
    this.newContactArray.push(new FormGroup(group));
    this.totalNewContactCount = this.newContactArray.length;
    console.log(this.newContactArray.length);
    group = {};
  }

  public get showAddButton() {
    return this.addContact.get("firstName").value !== "";
  }

  async addRecord(data: any) {
    console.log((data as FormGroup).valid);
    if (!(data as FormGroup).valid)
      return;
    this.AddNewWorkerControls(data.value);
    this.addContact = this.BlankContact();
    this.rosterArray.setValidators(this.rosterValidatorService.rosterValidator());
    this.rosterArray.updateValueAndValidity();
  }

  BlankContact(): FormGroup {
    return new FormGroup({
      "isSelected": new FormControl(true),
      "firstName": new FormControl(""),
      "middleName": new FormControl(""),
      "lastName": new FormControl(""),
      "memberType": new FormControl(""),
      "mobilePhone": new FormControl(""),
      "email": new FormControl("", Validators.email),
      "workPhone": new FormControl(""),
      "id": new FormControl(""),
      "status": new FormControl("")
    });
  }
}
